define.alias("ember-truth-helpers/helpers/gt", "settings/helpers/gt");